<template>
  <v-dialog
    :value="showDialog"
    @keydown.esc="closeDialog()"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Cadastro de Aula</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="save">
            <v-icon>mdi-check</v-icon>
            <div class="d-none d-sm-flex">Salvar</div>
          </v-btn>
          <v-btn dark text @click="closeDialog">
            <v-icon>mdi-close</v-icon>
            <div class="d-none d-sm-flex">Cancelar</div>
          </v-btn>
        </v-toolbar-items>
        <v-progress-linear
          :active="!gymClass"
          :indeterminate="true"
          absolute
          bottom
          color="primary lighten-2"
        ></v-progress-linear>
      </v-toolbar>
      <v-form v-model="valid" :disabled="!gymClass">
        <v-container>
          <div class="text-caption">Dados da aula</div>
          <v-container fluid class="ma-1 pa-1">
            <v-row align="start" justify="start">
              <v-col cols="12" md="4">
                <v-switch class="ma-0 pa-0" label="Aula ativa?" v-model="gymClass.isActive"></v-switch>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch
                  class="ma-0 pa-0"
                  label="Permite reserva?"
                  v-model="gymClass.allowsSchedule"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  type="number"
                  label="Capacidade máxima de alunos"
                  required
                  v-model.number="gymClass.maxCapacity"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="7">
                <v-text-field :counter="50" label="Nome da aula" required v-model="gymClass.name"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="start" justify="start">
              <v-col class="d-flex" cols="12" md="7">
                <v-select
                  :items="items"
                  label="Tipo de aula"
                  item-text="name"
                  item-value="id"
                  v-model="gymClass.classType"
                ></v-select>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-subheader class="pl-0">Horários das aulas na semana</v-subheader>
            <v-btn color="primary" :disabled="!gymClass" @click="novoHorario()">
              <v-icon left>mdi-plus</v-icon>Novo horário
            </v-btn>
            <class-time @change="sortArray()"></class-time>
            <v-row class="d-flex">
              <v-col>
                <v-divider></v-divider>
                <v-simple-table style="max-width:1050px">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th
                          v-for="day in weekDays"
                          :key="day.id"
                          class="text-center text-subtitle-2 center"
                        >{{ day.name }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <td
                        v-for="day in weekDays"
                        :key="day.id"
                        class="text-center align-top center"
                      >
                        <tr
                          v-for="(item, index) in gymClass.classSchedules"
                          :key="index + item.timeStart"
                        >
                          <v-card
                            v-if="item.dayOfWeek == day.id"
                            class="ma-1 pa-0"
                            rounded
                            hover
                            min-height="80"
                            width="120"
                          >
                            <div @click="showClassTime(item)" class="pa-2">
                              <div class="font-weight-black">{{ item.timeStart }}</div>
                              <div v-if="item.coachName" class="text-caption">{{ item.coachName }}</div>
                              <div v-else class="text-caption">--</div>
                              <div v-if="item.classRoom" class="text-caption">{{ item.classRoom }}</div>
                              <div v-else class="text-caption">--</div>
                            </div>

                            <v-btn
                              color="error"
                              dark
                              absolute
                              fab
                              x-small
                              max-height="20"
                              max-width="20"
                              @click="popItem(item.id, item.timeStart)"
                            >
                              <v-badge
                                color="green"
                                dot
                                overlap
                                offset-x="-45"
                                offset-y="-65"
                                :value="item.id == 0"
                              ></v-badge>
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-card>
                        </tr>
                      </td>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import ClassTime from "./ShowClassTime";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    ClassTime
  },
  data: () => ({
    loading: true,
    valid: null,
    items: [
      { id: 1, name: "Aulas coletivas" },
      { id: 2, name: "Sala de musculação" }
    ],
    weekDays: [
      { id: 0, name: "Domingo" },
      { id: 1, name: "Segunda" },
      { id: 2, name: "Terça" },
      { id: 3, name: "Quarta" },
      { id: 4, name: "Quinta" },
      { id: 5, name: "Sexta" },
      { id: 6, name: "Sábado" }
    ],
    newTime: {
      id: 0,
      classId: 0,
      classRoom: "",
      coachName: "",
      dayOfWeek: [],
      timeStart: "00:00",
      editMode: true
    }
  }),

  mounted() {
    this.loading = true;
  },
  methods: {
    ...mapActions("showClass", [
      "ActionFindClass",
      "ActionUpdateClass",
      "ActionSortClass",
      "ActionSetShowClassDialog",
      "ActionSetShowClassTimeDialog",
      "ActionReset",
      "ActionSetClassSchedule"
    ]),
    ...mapActions("units", ["ActionFindClassList"]),
    ...mapActions("snackbar", ["ActionSetSnackbar"]),

    async getData() {
      try {
        await this.ActionFindClass(this.$route.params.id);
      } catch (err) {
        // alert('Não foi possível carregar a página')
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.ActionSetShowClassDialog(false);
      this.ActionReset();
    },
    showClassTime(item) {
      this.ActionSetClassSchedule(item);
      this.ActionSetShowClassTimeDialog(true);
    },
    novoHorario() {
      this.newTime = {
        id: 0,
        classId: this.gymClass.id,
        classRoom: "",
        coachName: "",
        dayOfWeek: [2],
        timeStart: "05:00",
        editMode: true
      };
      this.ActionSetClassSchedule(this.newTime);
      this.ActionSetShowClassTimeDialog(true);
    },
    sortArray() {
      this.ActionSortClass(this.gymClass);
    },
    popItem(id, timeStart) {
      let array = this.gymClass.classSchedules;

      this.gymClass.classSchedules = array.filter(function(value) {
        return value.id != id || value.timeStart != timeStart;
      });
    },
    // save() {
    //   this.$emit("change");
    //   this.closeDialog();
    // },
    async save() {
      try {
        await this.ActionUpdateClass(this.gymClass);
        this.ActionSetSnackbar({
          color: "success",
          text: "Parabéns, salvo com sucesso!",
          timeout: 1000
        });
        // if (this.serie.watchlist) {
        //   await this.ActionDeleteFromWatchlist(this.serie.id)
        // }

        // if (this.serie.watched) {
        //   await this.ActionDeleteFromWatchedlist(this.serie.id)

        //   window.alert('Deletada com sucesso')
        // } else {
        //   await this.ActionAddOnWatchedlist({ serieId: this.serie.id })

        //   window.alert('Adicionada com sucesso')
        // }

        this.refresh();
        this.closeDialog();
      } catch (error) {
        this.ActionSetSnackbar({
          color: "error",
          text: "Oops, ocorreu alguma falha ao salvar!",
          timeout: 2000
        });
        console.error(error);
      }
    },
    refresh() {
      const { name } = this.$route;

      if (name === "home/registered-classes") {
        return this.ActionFindClassList(this.currentUnit);
      }
    }
  },
  computed: {
    ...mapState("showClass", ["gymClass", "showDialog"]),
    ...mapState("units", ["currentUnit"])
  },
  watch: {}
};
</script>
<style scoped>
.center {
  margin: auto;
  width: 120px;
  padding: 10px;
}
</style>
